module.exports = __webpack_public_path__ + "img/step3.d91471d.svg";